import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    vendorName: string | null;
    privacyPolicyUrl: string | null;
    className?: string;
}

export const UnlockChoiceModalDataSharingNotice = ({vendorName, privacyPolicyUrl, className}: IProps) => (
    <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" className={className}>
        Wraz ze zgłoszeniem prześlemy Twoje dane kontaktowe do {vendorName || "dewelopera"}, który będzie administratorem Twoich danych w tym zakresie i
        porozmawia z Tobą bez zobowiązań.
        {privacyPolicyUrl && (
            <>
                {" "}
                <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className={privacyPolicyLinkStyle}>
                    Polityka prywatności.
                </a>
            </>
        )}
    </Text>
);

const privacyPolicyLinkStyle = css({
    color: "var(--colors-secondary)",
    fontWeight: "bold",
    textDecoration: "underline",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    vendorName: string | null;
    privacyPolicyUrl: string | null;
    className?: string;
}

export const UnlockChoiceModalDataSharingNotice = ({vendorName, privacyPolicyUrl, className}: IProps) => (
    <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" className={className}>
        Wraz ze zgłoszeniem prześlemy Twoje dane kontaktowe do {vendorName || "dewelopera"}, który będzie administratorem Twoich danych w tym zakresie i
        porozmawia z Tobą bez zobowiązań.
        {privacyPolicyUrl && (
            <>
                {" "}
                <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className={privacyPolicyLinkStyle}>
                    Polityka prywatności.
                </a>
            </>
        )}
    </Text>
);

const privacyPolicyLinkStyle = css({
    color: "var(--colors-secondary)",
    fontWeight: "bold",
    textDecoration: "underline",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
